import { Outlet } from "react-router-dom";

/**
 * BareLayout — used for routes that manage their own full-screen flow
 * and sticky footer (Property Details' contact bar, Add Property's
 * wizard footer, a future Chat conversation view) — the persistent
 * <BottomNav /> would compete with those, so it is intentionally absent.
 */
export default function BareLayout() {
  return <Outlet />;
}
